import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class UserMgtServiceService {
  apiUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) {}

  getAllUsers(payload) {
    return this._http.get(`${this.apiUrl}/api/v1/meta-users/all`, {
      params: payload.params,
    });
  }

  whiteList(payload) {
    return this._http.put(
      `${this.apiUrl}/api/v1/meta-users/whitelist/${payload.appUserId}`,
      {}
    );
  }

  blacklist(payload) {
    return this._http.put(
      `${this.apiUrl}/api/v1/meta-users/blacklist/${payload.appUserId}`,
      payload.reason
    );
  }

  getBlockedUsers(payload) {
    return this._http.get(`${this.apiUrl}/api/v1/meta-users/blocked`, {
      params: payload.params,
    });
  }

  getRecentlyLoggedInUsers(payload) {
    return this._http.get(
      `${this.apiUrl}/api/v1/meta-users/recently-logged-in`,
      {
        params: payload.params,
      }
    );
  }
}
